import { Link } from "react-router-dom";
import LogoImage from "../../assets/images/logo.svg";

import * as S from "./styles";

export function Header() {
  return (
    <S.Container>
      <S.Content>
        <Link to="/">
          <img src={LogoImage} alt="Logo ComapreTaxa" />
        </Link>
      </S.Content>
    </S.Container>
  );
}
